import { MessageType, ScanStatus } from '../../../type';
import { RemoteRawFileMessage } from './RemoteRawFileMessage';
import { Box, Link } from '@mui/material';
import { RemoteImageMessage } from './RemoteImageMessage';
import { RemoteVideoMessage } from './RemoteVideoMessage';

type RemoteFileMessageProps = {
  messageType: Exclude<MessageType, 'TEXT'>;
  url?: string;
  thumbnailUrl?: string;
  fileName?: string;
  scanStatus?: ScanStatus;
  color?: string;
};

export const RemoteFileMessage = (props: RemoteFileMessageProps) => {
  const { url, color, messageType } = props;
  if (!url || url.startsWith('blob') || messageType === 'VIDEO') {
    return (
      <Box sx={{ color }}>
        <RemoteFileMessageInternal {...props} />
      </Box>
    );
  }
  return (
    <Link
      href={props.url}
      sx={{ color }}
      target='_blank'
      rel='noopener noreferrer'
    >
      <RemoteFileMessageInternal {...props} />
    </Link>
  );
};

const RemoteFileMessageInternal = (props: RemoteFileMessageProps) => {
  const { messageType, url, thumbnailUrl, fileName, scanStatus } = props;
  switch (messageType) {
    case 'PDF':
      return (
        <RemoteRawFileMessage
          icon={
            <Box
              component='img'
              src='/public/assets/icons/ic_pdf.svg'
              sx={{ height: 24, objectFit: 'cover' }}
            />
          }
          fileName={fileName}
          scanStatus={scanStatus}
        />
      );
    case 'WORD':
      return (
        <RemoteRawFileMessage
          icon={
            <Box
              component='img'
              src='/public/assets/icons/ic_word.svg'
              sx={{ height: 24, objectFit: 'cover' }}
            />
          }
          fileName={fileName}
          scanStatus={scanStatus}
        />
      );
    case 'IMAGE':
      return (
        <RemoteImageMessage
          url={url}
          thumbnailUrl={thumbnailUrl}
          fileName={fileName}
          scanStatus={scanStatus}
        />
      );
    case 'VIDEO':
      return (
        <RemoteVideoMessage
          url={url}
          thumbnailUrl={thumbnailUrl}
          fileName={fileName}
          scanStatus={scanStatus}
        />
      );
  }
};
